import { useQuery } from "@tanstack/react-query";
import type { Read } from "@/components/ui/box.schema";
import { useAuth } from "@/contexts/AuthContext";
import { ApiError } from "@/lib/api/client";
import { courseTopicsApi, type CourseTopics as Topics } from "@/lib/api/courseTopics";

export function useTopics(courseId: string, preparation: boolean, enabled = true) {
  const { me } = useAuth();
  return useQuery({ queryKey: ["course-topics", me?.tenant_id, me?.user_id, courseId, preparation],
    queryFn: () => courseTopicsApi.read(courseId, preparation), enabled: enabled && !!courseId, retry: false });
}
export function topicsRead(query: ReturnType<typeof useTopics>): Read<Topics> {
  if (query.error instanceof ApiError && [401, 403, 404].includes(query.error.status)) return { status: "forbidden" };
  if (!query.data) return query.isError ? { status: "failed", sentence: "Topics could not be read.", retry: () => void query.refetch() } : { status: "loading" };
  if (query.isError) return { status: "stale", last: query.data, readAt: query.data.read_at, sentence: "Topics could not be refreshed.", refresh: () => void query.refetch() };
  return { status: "ready", value: query.data, readAt: query.data.read_at };
}
